// extracted by mini-css-extract-plugin
export default {"failedCopiedText":"SaveJsonButton_failedCopiedText__k8nV0","successCopiedText":"SaveJsonButton_successCopiedText__jeOFy"};